/*
 * @Author: Dong
 * @Date: 2022-04-06 17:20:09
 * @LastEditors: Dong
 * @LastEditTime: 2022-04-24 16:18:55
 */
import React, { useEffect } from 'react';
import { Provider } from 'react-redux';
import { createHashHistory } from 'history';
import { HashRouter, useRoutes } from 'react-router-dom';
import { SupIntlProvider } from 'sup-rc-utility';
import { moduleResources } from './language';
import { routes } from './routers';
import store from './store/store';

const GetAllRoutes = () => useRoutes(routes);

// 路由history
window.hashHistory = createHashHistory();

// 验证权限，判断如果没有ticket,跳转到登录页
const ticket = localStorage.getItem('ticket');
if (!ticket) window.location.href = '#/login';

const App = () => {
  useEffect(() => {
    const beforeunloadFn = (event: any) => {
      const e = event || window.event;
      if (window.isBeforeunloadTip) {
        e.returnValue = '刷新浏览器显示二次确认';
        return '刷新浏览器显示二次确认';
      }
    };
    window.addEventListener('beforeunload', beforeunloadFn);
    return () => {
      window.removeEventListener('beforeunload', beforeunloadFn);
    };
  }, []);

  return (
    <HashRouter>
      <Provider store={store}>
        <SupIntlProvider
          cannotSendRequest={true}
          moduleCode="xxxx" // 模块code（i18n服务会定义各模块的code，可以问对应模块的后端要）
          moduleResources={moduleResources} // 本地国际化资源（本地开发用，生产环境下会自动与接口请求返回的国际化资源合并，以接口返回的为主）
        >
          <GetAllRoutes />
        </SupIntlProvider>
      </Provider>
    </HashRouter>
  );
};

export default App;
